var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.rowDataValue)?_c('div',{staticClass:"d-flex"},[_c('div',[_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.rowDataValue.name))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }